// @flow
import PlainDateInput, { defaultDateFormat, type Props as PlainDateInputProps } from './PlainDateInput';

export default PlainDateInput;
export { defaultDateFormat };
export type { PlainDateInputProps };
